import React, { useEffect, useRef, useState } from 'react';

// Keeps a horizontal scrollbar pinned to the window bottom while the target's own scrollbar is off-screen
export const PinnedHScroll = ({ targetRef, testId }) => {
  const barRef = useRef(null);
  const [box, setBox] = useState(null);

  useEffect(() => {
    const el = targetRef.current;
    if (!el) return undefined;
    const update = () => {
      const r = el.getBoundingClientRect();
      const needed = el.scrollWidth > el.clientWidth + 1;
      const offscreen = r.bottom > window.innerHeight && r.top < window.innerHeight - 40;
      setBox(needed && offscreen ? { left: r.left, width: r.width, inner: el.scrollWidth } : null);
    };
    const syncBar = () => { if (barRef.current) barRef.current.scrollLeft = el.scrollLeft; };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    el.addEventListener('scroll', syncBar);
    return () => {
      ro.disconnect();
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
      el.removeEventListener('scroll', syncBar);
    };
  }, [targetRef]);

  useEffect(() => { if (box && barRef.current && targetRef.current) barRef.current.scrollLeft = targetRef.current.scrollLeft; }, [box, targetRef]);

  if (!box) return null;
  return (
    <div ref={barRef} className="fixed bottom-0 z-40 overflow-x-auto overflow-y-hidden bg-background/95 border-t border-border shadow-[0_-2px_6px_rgba(0,0,0,0.06)]"
      style={{ left: box.left, width: box.width, height: 16 }}
      onScroll={(e) => { if (targetRef.current) targetRef.current.scrollLeft = e.currentTarget.scrollLeft; }}
      data-testid={testId}>
      <div style={{ width: box.inner, height: 1 }} />
    </div>
  );
};
